import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';

@Component({
    selector: 'qo-customer-support-showcase',
    templateUrl: './customer-support-showcase.component.html',
    imports: [CommonModule, RouterModule, MatRippleModule]
})
export class CustomerSupportShowcaseComponent {
  NavigationService = NavigationService;

  assetsPath = "assets/images/customer-support-showcase/";
}
